import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["TradingViewScript"] */ "/app/src/app/_lib/scripts/TradingViewScript.tsx");
